import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PermissionService } from './permission.service';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
  constructor(private permService: PermissionService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const permission = route.data['permission'];
    if (!permission) {
      return true;
    }
    if (!this.permService.hasPermission(permission)) {
      this.router.navigate(['/home']);
      return false;
    }
    return true;
  }
}
